import EfImg from '@elem/ui/ef-img';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import EfLink from '@elem/ui/ef-link';
import styles from './index.module.scss';
import { LangTextA } from './LangTextA';
import { IconWindow, IconLinux, IconMac, IconNat } from './Icons';
import { getUpsInfo } from '@/service';
import { createEFPic } from '@/utils/useEFPic';

interface DownLoadItemProps {
    cpu: string;
    os: 0 | 1 | 2 | 3; // 0-Windows，1-Linux/Unix，2-Mac 3-Net套件
    size: string;
    version: string;
    packageUrl: string;
    name?: string;
}

const { EFPic } = createEFPic('/media/support-download-index/');

export default function SupportDownloadA() {
    const { locale = 'us' } = useRouter();
    const TextA = LangTextA[locale] || LangTextA['us'];

    const [downloadInfo, setDownloadInfo] = useState<DownLoadItemProps[]>([]);

    const windows = downloadInfo.filter((item) => item.os === 0);
    const linux = downloadInfo.filter((item) => item.os === 1);
    const mac = downloadInfo.filter((item) => item.os === 2);
    const nat = downloadInfo.filter((item) => item.os === 3);

    useEffect(() => {
        const initInfo = async () => {
            const res = await getUpsInfo(locale);
            // console.log({res})
            if (res.code !== '200') return;

            // backend change data struct back and forth >:(
            const data = res?.data.map((ele: any) => {
                return ele?.upsPackage.map((item: any) => {
                    let fileSize = '';
                    if (item.size) {
                        const size = parseInt(item.size);
                        fileSize = `${size / 1024 / 1024}`.replace(/(\.\d{2})\d+/, '$1');
                    }
                    return {
                        ...item,
                        ...{
                            name: `${item.version || ''} (${item.cpu || ''}) | ${fileSize}MB`,
                        },
                    };
                });
            });
            const flattedData = data.flat();
            // console.log({ flattedData });
            setDownloadInfo(flattedData);
        };

        initInfo();
    }, []);

    return (
        <div className={styles.SupportDownloadA}>
            <div className="SupportDownloadA-l">
                <div className="SupportDownloadA-title">
                    <EFPic name={[`05-logo.webp`, `05-logo.png`]} alt={'logo'} className="logo logoPic" />
                    {TextA.title}
                </div>
                <div className="SupportDownloadA-desc">{TextA.desc}</div>
                {/* 延缓上线-暂时隐藏 */}
                <div className="SupportDownloadA-info">
                    <div className="text">{TextA.support}</div>
                    <EfLink
                        className="GtmModuleData-btn-href"
                        href={
                            ['nl']?.includes(locale)
                                ? 'https://manuals.ecoflow.com/eu/product/power-manager?lang=nl_NL&source=desktop'
                                : ['cn', 'tw'].includes(locale)
                                ? 'https://manuals.ecoflow.com/eu/product/power-manager?lang=zh_CN&source=desktop'
                                : 'https://manuals.ecoflow.com/eu/product/power-manager?lang=en_US&source=desktop'
                        }
                        dataLayer={{
                            __btn_id1: styles.SupportDownloadA_info,
                            __btn_id2: ['nl']?.includes(locale)
                                ? 'https://manuals.ecoflow.com/eu/product/power-manager?lang=nl_NL&source=desktop'
                                : ['cn', 'tw'].includes(locale)
                                ? 'https://manuals.ecoflow.com/eu/product/power-manager?lang=zh_CN&source=desktop'
                                : 'https://manuals.ecoflow.com/eu/product/power-manager?lang=en_US&source=desktop',
                        }}
                    >
                        {TextA.manual}
                        {' >'}
                    </EfLink>
                </div>
                {(windows.length > 0 || linux.length > 0 || mac.length > 0 || nat.length > 0) && (
                    <div className="SupportDownloadA-list">
                        {windows.length > 0 && (
                            <div className="SupportDownloadA-list-item">
                                <div className="SupportDownloadA-item">
                                    <IconWindow />
                                    <span className="SupportDownloadA-item-btnText">{TextA.itemA_1}</span>
                                    {/* <IconDownload /> */}
                                </div>
                                <div className="SupportDownloadA-links">
                                    {windows.map((item, key) => (
                                        <div className="SupportDownloadA-links-item" key={key}>
                                            <EfLink
                                                className="GtmModuleData-btn-href"
                                                href={item.packageUrl}
                                                target="_self"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'file_download',
                                                    file_name: item.name,
                                                    position: 'windowws',
                                                    button_name: item.name,
                                                    __btn_id1: styles.SupportDownloadA_info,
                                                    __btn_id2: item.packageUrl,
                                                }}
                                            >
                                                {item.name}
                                            </EfLink>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {linux.length > 0 && (
                            <div className="SupportDownloadA-list-item">
                                <div className="SupportDownloadA-item">
                                    <IconLinux />
                                    <span className="SupportDownloadA-item-btnText">{TextA.itemB_1}</span>
                                    {/* <IconDownload /> */}
                                </div>
                                <div className="SupportDownloadA-links">
                                    {linux.map((item, key) => (
                                        <div className="SupportDownloadA-links-item" key={key}>
                                            <EfLink
                                                className="GtmModuleData-btn-href"
                                                href={item.packageUrl}
                                                target="_self"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'file_download',
                                                    file_name: item.name,
                                                    position: 'Linux',
                                                    button_name: item.name,
                                                    __btn_id1: styles.SupportDownloadA_info,
                                                    __btn_id2: item.packageUrl,
                                                }}
                                            >
                                                {item.name}
                                            </EfLink>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {mac.length > 0 && (
                            <div className="SupportDownloadA-list-item">
                                <div className="SupportDownloadA-item">
                                    <IconMac />
                                    <span className="SupportDownloadA-item-btnText">{TextA.itemC_1}</span>
                                    {/* <IconDownload /> */}
                                </div>
                                <div className="SupportDownloadA-links">
                                    {mac.map((item, key) => (
                                        <div className="SupportDownloadA-links-item" key={key}>
                                            <EfLink
                                                className="GtmModuleData-btn-href"
                                                href={item.packageUrl}
                                                target="_self"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'file_download',
                                                    file_name: item.name,
                                                    position: 'Mac',
                                                    button_name: item.name,
                                                    __btn_id1: styles.SupportDownloadA_info,
                                                    __btn_id2: item.packageUrl,
                                                }}
                                            >
                                                {item.name}
                                            </EfLink>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {nat.length > 0 && (
                            <div className="SupportDownloadA-list-item">
                                <div className="SupportDownloadA-item">
                                    <IconNat />
                                    <span className="SupportDownloadA-item-btnText">{TextA.itemD_1}</span>
                                    {/* <IconDownload /> */}
                                </div>
                                <div className="SupportDownloadA-links">
                                    {nat.map((item, key) => (
                                        <div className="SupportDownloadA-links-item" key={key}>
                                            <EfLink
                                                className="GtmModuleData-btn-href"
                                                href={item.packageUrl}
                                                target="_self"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'file_download',
                                                    file_name: item.name,
                                                    position: 'NAS',
                                                    button_name: item.name,
                                                    __btn_id1: styles.SupportDownloadA_info,
                                                    __btn_id2: item.packageUrl,
                                                }}
                                            >
                                                {item.name}
                                            </EfLink>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {windows.length === 0 && linux.length === 0 && mac.length === 0 && nat.length === 0 && <div className="SupportDownloadA-tip">{TextA.tip}</div>}
            </div>
            <div className="SupportDownloadA-r">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1725525376780/ups_banner.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1725525303439/ups_banner_m.png"
                />
            </div>
        </div>
    );
}
